import { Timestamp } from "@/sx-layout/models/masters";

export const MarkType = {
  /* 高所 */ HEIGHT: { id: 1, color: "#000000", i18n: "mark_height" },
  /* 酸欠 */ OXYGEN_DEFICIENCY: { id: 2, color: "#215f9a", i18n: "mark_oxygen_deficiency" },
  /* 火気 */ FIRE: { id: 3, color: "#e2041b", i18n: "mark_fire" },
  /* RT */ RT: { id: 4, color: "#ffbe00", i18n: "mark_rt" },
  /* 仮置 */ TEMPORARY_PLACEMENT: { id: 5, color: "#a6a6a6", i18n: "mark_temporary_placement" },
  /* 危険物 */ HAZARDOUS_MATERIAL: { id: 6, color: "#d7660e", i18n: "mark_hazardous_material" },
  /* 石綿 */ ASBESTOS: { id: 7, color: "#006633", i18n: "mark_asbestos" },
  /* 汎用1 */ OTHER_1: { id: 8, color: "#65318e", i18n: "mark_other1" },
  /* 汎用2 */ OTHER_2: { id: 9, color: "#99ff00", i18n: "mark_other2" },
  /* 汎用3 */ OTHER_3: { id: 10, color: "#f593db", i18n: "mark_other3" },
} as const;

export type Mark = {
  mark_id: number;
  construction_id: number;
  layout_date: string;
  plot_plan_id: number;
  company_id: number;
  company_name: string;
  mark_type_id: number;
  x: number;
  y: number;
  use_start_hour: string;
  use_end_hour: string;
  work_content: string;
  user_id: number;
  charge_user_name: string;
  phone_number: string;
  color?: string;
  size?: number;
  note?: string;
  timestamp: Timestamp;
};
